import React from "react";
import { IoIosSearch } from "react-icons/io";
import { FormControl, Input, Select, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";

import MigrationPageViewModel from "./MigrationPageviewmodel"
import ModalAddMigrationScript from "./components/ModalAddMigrationScript";
import ModalDetailScriptFile from "./components/ModalDetailScriptFile";

function MigrationPageView() {
    const {
        headers,
        searchHelp,
        companyList,
        showScriptDetail,
        selectedFileContent,
        migrationScriptList,
        showAddMigrationScriptModal,

        handleSearchChange,
        setShowScriptDetail,
        fetchDataMigrationScript,
        handleOpenScriptFileDetail,
        handleDownloadFile,
        setShowAddMigrationScriptModal,
        handleConfirmAddMigrationScript
    } = MigrationPageViewModel();

    return (
        <React.Fragment>
            <div className="flex flex-row justify-evenly">
                <div className="grid grid-cols-2 gap-4">
                    <div className="flex items-center gap-2">
                        <label
                            htmlFor="company-header"
                            className="w-1/4"
                        >
                            Company :
                        </label>
                        <Select
                            placeholder="กรุณาระบุ Company"
                            onChange={e => {
                                handleSearchChange('company', e.target.value);
                            }}
                            width="sm"
                        >
                            {companyList &&
                                companyList.map((value, index) => (
                                    <option
                                        key={index}
                                        value={value.value}
                                    >
                                        {value.name}
                                    </option>
                                ))}
                        </Select>
                    </div>
                    <div className="flex items-center gap-2">
                        <label
                            htmlFor="company-header"
                            className="w-1/4"
                        >
                            Type :
                        </label>
                        <Select
                            placeholder="Type"
                            onChange={e => {
                                handleSearchChange('type', e.target.value);
                            }}
                            width="sm"
                        >
                            <option value="UatAndPrd">UAT&PRD </option>
                            <option value="UatOnly">UAT ONLY</option>
                            <option value="PrdOnly">PRD ONLY</option>
                            <option value="PrdDataConfig">PRD (DataConfig)</option>
                            <option value="PrdTableChange">PRD (TableChange)</option>
                            <option value="Schemas">Schemas</option>
                        </Select>
                    </div>
                    <div className="flex items-center gap-2">
                        <label
                            htmlFor="company-header"
                            className="w-1/4"
                        >
                            TK :
                        </label>
                        <div className="flex-1">
                            <Input
                                placeholder="Ticket No."
                                value={searchHelp.tk}
                                onChange={e => handleSearchChange('tk', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <label
                            htmlFor="company-header"
                            className="w-1/4"
                        >
                            File Name :
                        </label>
                        <div className="flex-1">
                            <Input
                                placeholder="File Name"
                                value={searchHelp.fileName}
                                onChange={e => handleSearchChange('fileName', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="flex items-center gap-2">
                        <label
                            htmlFor="company-header"
                            className="w-1/4"
                        >
                            Develop :
                        </label>
                        <div className="flex-1">
                            <Input
                                placeholder="Develop"
                                value={searchHelp.develop}
                                onChange={e => handleSearchChange('develop', e.target.value)}
                            />
                        </div>
                    </div>
                    {migrationScriptList &&
                        <div className="flex items-center gap-2 justify-end">
                            <button
                                className="rounded-2xl border-2 px-4 py-2"
                                onClick={handleDownloadFile}
                            >
                                Download File
                            </button>
                        </div>
                    }
                </div>
                <div className="flex flex-col items-end gap-5">
                    <button
                        className="rounded-2xl border-2 px-4 py-2"
                        onClick={fetchDataMigrationScript}
                    >
                        Search
                    </button>
                    <button
                        className="rounded-2xl border-2 px-4 py-2"
                        onClick={setShowAddMigrationScriptModal.on}
                    >
                        Add Migration Script
                    </button>
                </div>
            </div>
            <div className="mt-5 border-t-2">
                {migrationScriptList &&
                    <TableContainer
                        whiteSpace="wrap"
                        className="mt-2"
                    >
                        <Table
                            size="sm"
                            variant="unstyled"
                        >
                            <Thead>
                                <Tr>
                                    {headers.map(header => (
                                        <Th
                                            key={header}
                                            className="border text-center"
                                            style={{
                                                borderColor:
                                                    'rgb(212 212 212 / var(--tw-border-opacity)) !important'
                                            }}
                                        >
                                            {header}
                                        </Th>
                                    ))}
                                </Tr>
                            </Thead>
                            <Tbody>
                                {migrationScriptList ? (
                                    migrationScriptList.map((value, index) => (
                                        <Tr
                                            key={index}
                                            className="[&>td]:border [&>td]:border-neutral-300"
                                        >
                                            <Td className="text-center">{value.company}</Td>
                                            <Td>{value.file_name}</Td>
                                            <Td className="text-center">{value.type}</Td>
                                            <Td className="text-center">{value.tk}</Td>
                                            <Td>{value.detail}</Td>
                                            <Td>{value.remark}</Td>
                                            <Td>{value.created_by}</Td>
                                            <Td
                                                className="text-center"
                                                onClick={() => {
                                                    handleOpenScriptFileDetail({ s3_file_path: value.s3_file_path, s3_guid: value.s3_guid });
                                                }}>
                                                <button>
                                                    <IoIosSearch size={24} />
                                                </button>
                                            </Td>
                                        </Tr>
                                    ))
                                ) : (
                                    <tr className="text-center">
                                        <td colSpan={headers.length}>
                                            <span>No data..</span>
                                        </td>
                                    </tr>
                                )}
                            </Tbody>
                        </Table>
                    </TableContainer>
                }
            </div>

            <ModalAddMigrationScript
                isOpen={showAddMigrationScriptModal}
                onClose={setShowAddMigrationScriptModal.off}
                handleConfirmAddMigrationScript={handleConfirmAddMigrationScript}
                company={companyList}
            />

            <ModalDetailScriptFile
                isOpen={showScriptDetail}
                onClose={setShowScriptDetail.off}
                selectedFileContent={selectedFileContent}
            />
        </React.Fragment >
    )
}

export default MigrationPageView